export const bgColorConfig= [{
						headerRightBg: '#1aa094', //头部右侧背景色
						headerRightBgThis: '#197971', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#1aa094', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#0c0c0c', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#23262e', //左侧菜单背景,
						leftMenuBgThis: '#1aa094', //左侧菜单选中背景,
						leftMenuChildBg: '#0c0f13', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#1aa094', //tab选项卡选中颜色,
					},
	                {
						headerRightBg: '#ffffff', //头部右侧背景色
						headerRightBgThis: '#e4e4e4', //头部右侧选中背景色,
						headerRightColor: 'rgba(107, 107, 107, 0.7)', //头部右侧字体颜色,
						headerRightChildColor: 'rgba(107, 107, 107, 0.7)', //头部右侧下拉字体颜色,
						headerRightColorThis: '#565656', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(160, 160, 160, 0.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#1E9FFF', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#565656', //头部缩放按钮样式,
						headerLogoBg: '#192027', //logo背景颜色,
						headerLogoColor: 'rgb(191, 187, 187)', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#28333E', //左侧菜单背景,
						leftMenuBgThis: '#1E9FFF', //左侧菜单选中背景,
						leftMenuChildBg: '#0c0f13', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#1e9fff', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#23262e', //头部右侧背景色
						headerRightBgThis: '#0c0c0c', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#1aa094', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#0c0c0c', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#23262e', //左侧菜单背景,
						leftMenuBgThis: '#737373', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#23262e', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#ffa4d1', //头部右侧背景色
						headerRightBgThis: '#bf7b9d', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#ffa4d1', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#e694bd', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#1f1f1f', //左侧菜单背景,
						leftMenuBgThis: '#737373', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#ffa4d1', //tab选项卡选中颜色,
					},					
					{
						headerRightBg: '#1e9fff', //头部右侧背景色
						headerRightBgThis: '#0069b7', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#1e9fff', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#0c0c0c', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#1f1f1f', //左侧菜单背景,
						leftMenuBgThis: '#1e9fff', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#1e9fff', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#ffb800', //头部右侧背景色
						headerRightBgThis: '#d09600', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#d09600', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#243346', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#2f4056', //左侧菜单背景,
						leftMenuBgThis: '#8593a7', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#ffb800', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#e82121', //头部右侧背景色
						headerRightBgThis: '#ae1919', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#ae1919', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#0c0c0c', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#1f1f1f', //左侧菜单背景,
						leftMenuBgThis: '#3b3f4b', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#e82121', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#963885', //头部右侧背景色
						headerRightBgThis: '#772c6a', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#772c6a', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#243346', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#2f4056', //左侧菜单背景,
						leftMenuBgThis: '#586473', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#963885', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#2D8CF0', //头部右侧背景色
						headerRightBgThis: '#0069b7', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#0069b7', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#0069b7', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#1f1f1f', //左侧菜单背景,
						leftMenuBgThis: '#2D8CF0', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#2d8cf0', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#ffb800', //头部右侧背景色
						headerRightBgThis: '#d09600', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#d09600', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#ffb800', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#ffffff', //左侧菜单背景,
						leftMenuBgThis: '#e6f7ff', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(239, 239, 239, 0.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(103, 103, 103)', //左侧菜单字体颜色,
						leftMenuColorThis: '#1890ff', //左侧菜单选中字体颜色,
						tabActiveColor: '#ffb800', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#e82121', //头部右侧背景色
						headerRightBgThis: '#ae1919', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#ae1919', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#d91f1f', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#1f1f1f', //左侧菜单背景,
						leftMenuBgThis: '#3b3f4b', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#e82121', //tab选项卡选中颜色,
					},
					{
						headerRightBg: '#963885', //头部右侧背景色
						headerRightBgThis: '#772c6a', //头部右侧选中背景色,
						headerRightColor: 'rgba(255,255,255,.7)', //头部右侧字体颜色,
						headerRightChildColor: '#676767', //头部右侧下拉字体颜色,
						headerRightColorThis: '#ffffff', //头部右侧鼠标选中,
						headerRightNavMore: 'rgba(255,255,255,.7)', //头部右侧更多下拉颜色,
						headerRightNavMoreBg: '#772c6a', //头部右侧更多下拉列表选中背景色,
						headerRightNavMoreColor: '#ffffff', //头部右侧更多下拉列表字体色,
						headerRightToolColor: '#bbe3df', //头部缩放按钮样式,
						headerLogoBg: '#772c6a', //logo背景颜色,
						headerLogoColor: '#ffffff', //logo字体颜色,
						leftMenuNavMore: 'rgb(191, 187, 187)', //左侧菜单更多下拉样式,
						leftMenuBg: '#2f4056', //左侧菜单背景,
						leftMenuBgThis: '#626f7f', //左侧菜单选中背景,
						leftMenuChildBg: 'rgba(0,0,0,.3)', //左侧菜单子菜单背景,
						leftMenuColor: 'rgb(191, 187, 187)', //左侧菜单字体颜色,
						leftMenuColorThis: '#ffffff', //左侧菜单选中字体颜色,
						tabActiveColor: '#963885', //tab选项卡选中颜色,
					}
				];			
function buildThemeCss(bgcolorId) {	
				let bgcolorData = bgColorConfig[bgcolorId];
				let styleHtml = '/*头部右侧背景色 headerRightBg */' +
					'.el-menu-demo,.el-header {' +
					'    background-color: ' + bgcolorData.headerRightBg + ' !important;' +
					'}' +
					'/*头部右侧选中背景色 headerRightBgThis */' +
					'.el-header  i:hover {' +
					'    background-color: ' + bgcolorData.headerRightBgThis + ' !important;' +
					'}' +
					'/*头部右侧字体颜色 headerRightColor */' +
					'.el-header i,.el-header span{' +
					'    color:  ' + bgcolorData.headerRightColor + ';' +
					'}' +
					'/**头部右侧下拉字体颜色 headerRightChildColor */' +
					'.el-popper .el-dropdown-menu__item{' +
					'    color:  ' + bgcolorData.headerRightChildColor + '!important;' +
					'}' +
					'/*头部右侧鼠标选中 headerRightColorThis */' +
					'.el-header a:hover {' +
					'    color: ' + bgcolorData.headerRightColorThis + ' !important;' +
					'}' +
					'' +					
					'/*头部缩放按钮样式 headerRightToolColor */' +
					'.el-logo .el-image {' +
					'    color: ' + bgcolorData.headerRightToolColor + ';' +
					'}' +
					'/*logo背景颜色 headerLogoBg */' +
					'.el-logo {' +
					'    background-color: ' + bgcolorData.headerLogoBg + ' !important;' +
					'}' +
					'/*logo字体颜色 headerLogoColor */' +
					'.el-logo span,.ele-logo span{' +
					'    color: ' + bgcolorData.headerLogoColor + ';' +
					'}' +
					'/*左侧菜单更多下拉样式 leftMenuNavMore */' +
					'.el-menu-vertical-demo .layuimini-menu-left .layui-nav-more {' +
					'    border-top-color: ' + bgcolorData.leftMenuNavMore + ';' +
					'}' +
					'/*左侧菜单背景 leftMenuBg */' +
					'.menu,.el-menu-vertical-demo  {' +
					'    background-color:  ' + bgcolorData.leftMenuBg + ' !important;' +
					'}' +
					'/*左侧菜单选中背景 leftMenuBgThis */' +
					'.el-menu-vertical-demo .el-menu  .is-active,.el-menu-vertical-demo  .is-active,.el-menu-vertical-demo .el-submenu .is-active,.el-menu--popup-right-start .is-active {' +
					'background-color: ' + bgcolorData.leftMenuBgThis + ' !important' +
					'}' +
					'/*左侧菜单子菜单背景 leftMenuChildBg */' +
					'.el-menu-vertical-demo  .el-submenu .el-menu {' +
					'background-color: ' + bgcolorData.leftMenuChildBg + ' !important;' +
					'}' +
					'/*左侧菜单子菜单背景 leftMenuChildBg */' +
					'.el-menu-vertical-demo .el-submenu ,.el-menu--popup-right-start {' +
					'background-color: ' + bgcolorData.leftMenuBg + ' !important;' +
					'}' +					
					'/*左侧菜单字体颜色 leftMenuColor */' +
					'.el-menu-vertical-demo .el-submenu__title i,.el-menu-vertical-demo .el-submenu__title span,.el-menu-vertical-demo .el-menu-item,.el-menu--popup-right-start .el-submenu__title {' +
					' color:  ' + bgcolorData.leftMenuColor + ' !important;' +
					'}' +
					'/*左侧菜单鼠标经过颜色 */' +
					'.el-menu-vertical-demo .el-submenu  .el-submenu__title:hover,.el-menu-vertical-demo  .el-menu-item:hover,.el-menu--popup-right-start li:hover,.el-menu--popup-right-start  .el-submenu__title:hover{' +
					'background-color: ' + bgcolorData.leftMenuBgThis + ' !important;' +
					'}' +
					'/*左侧菜单选中字体颜色 leftMenuColorThis */' +
					'.el-menu-vertical-demo  .is-active,.el-menu-vertical-demo .el-menu  .is-active span,.el-menu-vertical-demo .el-menu  .is-active i,.el-menu--popup-right-start li {' +
					'color:' + bgcolorData.leftMenuColorThis + ' !important;' +
					'}' +
					//顶部样式定义
					'/*顶部菜单背景 headerRightBg */' +
					'.el-menu-demo,.el-menu-demo .el-menu-item:focus  {' +
					'    background-color:  ' + bgcolorData.headerRightBg + ' !important;' +
					'}' +
					'/*顶部菜单选中背景 leftMenuBgThis */' +
					'.el-menu-demo .el-menu-item:hover,.el-menu-demo .is-active,.el-menu-demo .isActive,.el-menu-demo .el-submenu__title:hover,.el-menu--horizontal .el-menu--popup  .is-active {' +
					'background-color: ' + bgcolorData.headerRightBgThis + ' !important' +
					'}' +
					'/*顶部菜单子菜单背景 headerRightBgThis */' +
					'.el-menu--horizontal .el-menu--popup div,.el-menu--horizontal .el-menu--popup .el-submenu ul li {' +
					'background-color: ' + bgcolorData.headerRightBgThis + ' !important;' +
					'}' +
					'/*顶部菜单字体颜色 headerRightColor */' +
					'.el-menu-demo .el-submenu__title .el-icon-setting,.el-menu-demo .el-submenu__title span{' +
					' color:  ' + bgcolorData.headerRightColor + ' !important;' +
					'}' +
					'/*顶部菜单鼠标经过颜色 headerRightBgThis*/' +
					'.el-menu--popup-bottom-start .el-menu-item:hover,.el-menu-demo  .el-menu-item:hover,.el-menu--popup-bottom-start li:hover{' +
					'background-color: ' + bgcolorData.headerRightBgThis + ' !important;' +
					'}' +
					'/*顶部菜单选中字体颜色 headerRightColorThis*/' +
					'.el-menu-demo .isActive span,.el-menu-demo .isActive i,.el-menu-demo .is-active span,.el-menu-demo .is-active .el-submenu__title i,.el-menu--popup-bottom-start  .is-active,.el-menu--popup-bottom-start .el-submenu .el-submenu__title {' +
					'color:' + bgcolorData.headerRightColorThis+ ' !important;' +
					'}' +				
					'/**tab选项卡选中颜色 tabActiveColor */' +
					'.el-scrollbar__view .active {' +
					'    background-color: ' + bgcolorData.tabActiveColor + ' !important;' +
					'    border-color: ' + bgcolorData.tabActiveColor + ' !important;' +
					'}';
				return (styleHtml);
	}	
export const CreateCss=function (e){
	let newStyle=buildThemeCss(e)
	let styleTag = document.getElementById('xxsoft_style')
	if (!styleTag) {
	  styleTag = document.createElement('style')
	  styleTag.setAttribute('id', 'xxsoft_style')
	  document.head.appendChild(styleTag)
	}
	styleTag.innerText = newStyle
}				